import React, { useContext } from "react";
import { PromoContext } from "@context/PromoContext";
import TextInput from "@components/Ui/TextInput";
import "./style.scss";

const PromoCodeInput = ({ success }) => {
    const { standardPromoCode, setStandardPromoCode } = useContext(PromoContext);

    const inputClass = (success === true)
        ? "promo-code-input__success"
        : (success === false)
            ? "promo-code-input__error"
            : "";

    return (
        <TextInput
            value={standardPromoCode}
            onChange={(e) => setStandardPromoCode(e.target.value)}
            placeholder="Enter Promo Code"
            additionalClasses={`text-input__field--wide ${inputClass}`}
        />
    );
};

export default PromoCodeInput;
